export function mod11(string: string) {
  const digits = string.replace(/\D/g, '')
  const checkNumber = parseInt(digits.slice(-1))
  const digitsWithoutCheckNumber = digits.slice(0, -1)
  let sum = 0

  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2].slice(
    -digitsWithoutCheckNumber.length,
  )

  for (let index = 0; index < 10; index++) {
    const weight = weights[index]

    if (weight) {
      sum += parseInt(digitsWithoutCheckNumber.slice(index, index + 1)) * weight
    }
  }

  const remainder = sum % 11

  return checkNumber === (remainder === 0 ? 0 : 11 - remainder)
}
